<template>
    <div class="add-location-to-waypoints">
        <SmrButton color="grey" v-if="showAsBetweenButton" @click.native="addToWaypoints('between', 'Set as Stop')">Als Zwischenziel</SmrButton>
        <SmrButton :color="showAsBetweenButton ? 'yellow' : 'grey'" v-if="showAsStartButton" @click.native="addToWaypoints('start', 'Set as Starting Point')">Als Start</SmrButton>
        <SmrButton v-if="showAsEndButton" @click.native="addToWaypoints('end', 'Set as Destination')">Als Ziel</SmrButton>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SmrButton from '@/components/SmrButton.vue'
import { trackEvent } from '@/utils/tracking'

export default {
    components: {
        SmrButton,
    },
    props: {
        trackingData: {
            type: [Object, Boolean],
            default: false
        },
    },
    computed: {
        ...mapGetters(['waypointPositions']),
        anyFilled() {
            return this.waypointPositions.start || this.waypointPositions.end;
        },
        showAsStartButton() {
            return !this.waypointPositions.start || !this.anyFilled
        },
        showAsBetweenButton() {
            return this.anyFilled;
        },
        showAsEndButton() {
            return !this.waypointPositions.end || !this.anyFilled
        }
    },
    methods: {
        addToWaypoints(position, trackingLabel) {
            this.$emit('addToWaypoints', { position })
            if(this.trackingData) {
                trackEvent({...this.trackingData, label: trackingLabel})
            }
        }
    }
}
</script>

<style lang="scss">
.add-location-to-waypoints {
    $block: &;
    display: flex;
    margin: 24px -3px 0;
    
    & > * {
        width: 100%;
        margin: 0 3px;
    }
}
</style>